import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { generateCacheKey, withManualCache } from '@/utlility/cache-service';
const API_URL = process.env.NEXT_PUBLIC_API_URL;


export const fetchTestimonials = createAsyncThunk(
  'testimonials/fetchTestimonials',
  async ({payload}, { rejectWithValue }) => {
    try {
      const url = `${API_URL}/api/testimonials`;
      const cacheKey = generateCacheKey(url, 'POST', payload);
      return await withManualCache(cacheKey, async () => {
        const response = await axios.post(url, payload);
        return response.data;
      });
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Unknown error';
      return rejectWithValue({ message: errorMessage });
    }
  }
);


const testimonialsSlice = createSlice({
  name: 'testimonials',
  initialState: {
    testimonials: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTestimonials.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchTestimonials.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.testimonials = action.payload.data;
      })
      .addCase(fetchTestimonials.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export default testimonialsSlice.reducer;
